import { reactive } from 'vue'
import { supabase } from '@/supabase.js';


export const _store = reactive({
    quizdata: [],
    async quizFetch(){
        const {data , error} = await supabase.from('questions').select('*');
        if (error) {
        console.error(error);
        }else {      
        this.quizdata=data;

        }
}


  
})